import React from 'react';
import { useSelector } from 'react-redux';
import { selectInstitution } from '../../../../store/features/system/selectors';
import './BrandedLogo.scss';
export const BrandedLogo = ({ className }) => {
    const institution = useSelector(selectInstitution);
    const logoSrc = institution?.logoHorizontal;
    if (!logoSrc) {
        return null;
    }
    return (<div className={`ml-branded-logo ${className ?? ''}`}>
      <img src={logoSrc} alt="Branded Logo"/>
    </div>);
};
